export type KioskPayState = {
  address: string
  code: string
  requestId: string | null
  credential: string | null
}

export const initialKioskPayState: KioskPayState = {
  address: '',
  code: '',
  requestId: null,
  credential: null,
}

export type KioskPayAction =
  | { type: 'address'; value: string }
  | { type: 'code'; value: string }
  | { type: 'requested'; requestId: string }
  | { type: 'verified'; credential: string }
  | { type: 'restart' }

/** The shared screen's claim and credential live only for its mounted flow. */
export function kioskPayReducer(
  state: KioskPayState,
  action: KioskPayAction,
): KioskPayState {
  switch (action.type) {
    case 'address':
      return { ...state, address: action.value }
    case 'code':
      return { ...state, code: action.value.replace(/\D/g, '').slice(0, 6) }
    case 'requested':
      return { ...state, requestId: action.requestId }
    case 'verified':
      return { ...state, credential: action.credential }
    case 'restart':
      return initialKioskPayState
  }
}
